import "./Input.css";

import classnames from "classnames";

import Error from "./Error";
import type React from "react";

export interface InputProps {
  id: string;
  label: string;
  type: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  errors?: { message: React.ReactNode; id: string }[];
  autoComplete?: string;
}

export default function Input({
  label,
  id,
  type,
  value,
  onChange,
  required,
  autoComplete,
  errors = [],
}: InputProps) {
  const className = classnames("Input", {
    "Input--error": errors && errors.length > 0,
    "Input--required": required,
  });

  return (
    <div className={className}>
      <label htmlFor={id}>{label}</label>
      <input
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        required={required || false}
        autoComplete={autoComplete}
      />
      {errors && errors.length > 0 && (
        <div>
          {errors.map((error) => (
            <Error key={error.id}>{error.message}</Error>
          ))}
        </div>
      )}
    </div>
  );
}
